import * as issueAppearMethods from "./issueAppearMethods";
import i18n from "@/common/lang.serivce";

const IssueAppearMethods = {
  list() {
    return Object.keys(issueAppearMethods);
  },
  getAll() {
    return this.list().map(issueAppearMethod => {
      return {
        value: issueAppearMethod,
        text: i18n.t("issueAppearMethods." + issueAppearMethod)
      };
    });
  }
};

export default IssueAppearMethods;
